// PWA — 最近任务列表组件（Req 8.5 / 任务 9.7）
//
// 展示本地 IndexedDB 里最近的生成记录（提示词、参数、时间），支持点击重新查看
// 该任务（回到"生成结果"轮询/展示）。数据由上层 useRecent 提供并下传。

import type { UseRecentResult } from "./useRecent.js";

export interface RecentListProps {
  /** useRecent 的返回值（由上层 App 持有并下传）。 */
  recent: UseRecentResult;
  /** 是否已认证：未认证时提示先登录。 */
  authenticated: boolean;
  /** 点击某条记录：回到"生成结果"重新查看该 jobId（可选）。 */
  onSelect?: (jobId: string) => void;
}

/** 毫秒时间戳 → 本地可读时间。 */
function formatTime(ms: number): string {
  try {
    return new Date(ms).toLocaleString();
  } catch {
    return "";
  }
}

export function RecentList({
  recent,
  authenticated,
  onSelect,
}: RecentListProps): JSX.Element {
  const { recent: items, loading, error, clear } = recent;

  return (
    <section className="card" aria-label="最近任务">
      <div className="recent__header">
        <h2 className="card__title">最近任务</h2>
        {authenticated && items.length > 0 && (
          <button
            type="button"
            className="btn btn--small"
            onClick={() => void clear()}
          >
            清空
          </button>
        )}
      </div>

      {!authenticated ? (
        <p className="app__hint">登录后可查看最近的生成记录。</p>
      ) : loading ? (
        <p className="app__hint">正在加载最近任务…</p>
      ) : error ? (
        <p className="app__hint" role="alert">
          读取最近任务失败：{error.message}
        </p>
      ) : items.length === 0 ? (
        <p className="app__hint">还没有最近任务，提交一次生成就会出现在这里。</p>
      ) : (
        <ul className="recent__list">
          {items.map((it) => (
            <li key={it.jobId} className="recent__item">
              <button
                type="button"
                className="recent__item-btn"
                onClick={() => onSelect?.(it.jobId)}
                title="重新查看该任务"
              >
                <span className="recent__prompt">
                  {it.prompt || "（无提示词）"}
                </span>
                <span className="recent__meta">
                  {it.params.width}×{it.params.height} · {it.params.steps} 步 ·{" "}
                  {formatTime(it.createdAt)}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
